export const Report_REQUEST = "Report_REQUEST";
export const Report_SUCCESS = "Report_SUCCESS";
export const Report_FAIL = "Report_FAIL";